import {apiBase} from './ApiBase'
import camelcaseKeys from "camelcase-keys"
import {Card} from "@/entity/Card";

export const getCardList = async () => {
  const result = await apiBase.get(`/cards`, {})
  return camelcaseKeys(result.data.data, { deep: true }).map((c) => {
    return new Card(c);
  })
}

export const getCard = async ({id}) => {
  const result = await apiBase.get(`/cards/${id}`)
  return new Card(camelcaseKeys(result.data.data, { deep: true }))
}

// Public card endpoints
export const getPublicCard = async ({id}) => {
  const result = await apiBase.get(`/publicCards/${id}`)
  return new Card(camelcaseKeys(result.data.data, { deep: true }))
}

export const getCardImage = async ({id}) => {
  const result = await apiBase.get(`/cards/${id}/image`, {}, { responseType: 'blob' })
  return result.data
}

export const getbackSideCardImage = async ({id}) => {
  const result = await apiBase.get(`/cards/${id}/image/backSide`, {}, { responseType: 'blob' })
  return result.data
}

// Public card images
export const getPublicCardImage = async ({id}) => {
  const result = await apiBase.get(`/publicCards/${id}/image`, {}, { responseType: 'blob' })
  return result.data
}

export const getPublicBackSideCardImage = async ({id}) => {
  const result = await apiBase.get(`/publicCards/${id}/image/backSide`, {}, { responseType: 'blob' })
  return result.data
}

export const addCard = async ({ card }) => {
  const result = await apiBase.post(`/cards`, card.exportForAdd())
  const data = await result.data
  return new Card(camelcaseKeys(data, { deep: true }))
}

export const update = async ({ id, card }) => {
  const result = await apiBase.put(`/cards/${id}`, card.export())
  const data = await result
  return new Card(camelcaseKeys(data.data, { deep: true }))
}

export const deleteCard = async ({ id, card }) => {
  await apiBase.delete(`/cards/${id}`)
}

export const readByOCR = async ({ id }) => {
  const result = await apiBase.get(`/cards/${id}/ocr`)
  const data = await result
  return (data.data || {}).data || []
}

